
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Login from '../pages/login/page';
import Dashboard from '../pages/dashboard/page';
import Team from '../pages/team/page';
import AutoQuote from '../pages/auto-quote/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
  },
  {
    path: '/team',
    element: <Team />,
  },
  {
    path: '/auto-quote',
    element: <AutoQuote />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
